import classes from "@/styles/fulfilment-partners/purolator.module.css";
import { purolator } from "@/utils/content";
import Image from "next/image";
import { FaDotCircle, FaTruck } from "react-icons/fa";
import { BiCurrentLocation } from "react-icons/bi";
import { GiEarthAmerica } from "react-icons/gi";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
  Col,
  Container,
  Row,
} from "reactstrap";
import Link from "next/link";
import { useState } from "react";
import IntegrationDetails from "../partners/integration-details";
import { logo, smallLogo } from "@/utils/images";
import { AiOutlinePlus } from "react-icons/ai";
import { useIsMobile } from "@/hooks/useIsMobile";

const PurolatorService = () => {
  const isMobile = useIsMobile();

  const content = purolator.en;

  const [open, setOpen] = useState<string>("1");

  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <main className={classes.container}>
      {/* section4 */}
      <section className="mb-5 container">
        <Card className={classes.cardBg}>
          <CardBody className="p-5">
            <div className="text-center">
              <h3>{content.section4.title}</h3>
              <p>{content.section4.para}</p>
            </div>
            <Row>
              {content.section4.services.map((s, i) => {
                return (
                  <Col xs={12} lg={4} key={i}>
                    <Link className="my-3 d-block" href={`/partners${s.link}`}>
                      <Card className={classes.serviceCard}>
                        <CardBody className="text-white">
                          <h5>{s.title}</h5>
                          <p>{s.desc}</p>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                );
              })}
            </Row>
          </CardBody>
        </Card>
      </section>
      {/* section6 */}
      <section className="my-5 container">
        <Row>
          <Col xs={12} lg={3}>
            <h3>{content.section5.title}</h3>
            <p>{content.section5.para}</p>
          </Col>
          <Col xs={12} lg={9}>
            {/*@ts-ignore*/}
            <Accordion open={open} toggle={toggle}>
              {content.section5?.faqs?.map((f, i) => {
                return (
                  <AccordionItem key={i}>
                    <AccordionHeader targetId={(i + 1).toString()}>
                      {f.title}
                    </AccordionHeader>
                    <AccordionBody accordionId={(i + 1).toString()}>
                      <p>{f.desc}</p>
                    </AccordionBody>
                  </AccordionItem>
                );
              })}
            </Accordion>
          </Col>
        </Row>
      </section>
      {/* section6 */}
      {/* <section className="my-5 container">
        <h3>{content.section6.title}</h3>
        <IntegrationDetails partnerDetails={content} />
      </section> */}
    </main>
  );
};

export default PurolatorService;
